import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbField } from "abreact/form/AbField";
import * as AbFormHooks from "abreact/form/AbFormHooks";
import { AbStringDataValueInput } from "abreact/input/AbStringDataValueInput";
import * as React from "react";
export function AbStringField(props) {
  const viewModel = AbFormHooks.useDataValueFieldViewModel("ab-string-field", props);
  if (!viewModel) {
    return null;
  }
  const singleLine = props.singleLine || props.accessor.constraints?.singleLine === true || !viewModel.isEditing && viewModel.currentValue === null;
  return /*#__PURE__*/React.createElement(AbField, _extends({}, viewModel.fieldProps, {
    singleLine: singleLine,
    fullWidth: viewModel.isEditing
  }), /*#__PURE__*/React.createElement(AbStringDataValueInput, _extends({}, viewModel.inputProps, {
    valueRenderer: props.valueRenderer,
    singleLine: singleLine
  })));
}
//# sourceMappingURL=AbStringField.js.map
